import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Pipe({
    name: 'translate',
    standalone: true,
    pure: false // Necesario para reaccionar al cambio de Signal currentLang()
})
export class TranslatePipe implements PipeTransform {
    private langService = inject(LanguageService);

    transform(value: any, paramsOrKey?: any): string {
        if (!value) return '';

        const currentLang = this.langService.currentLang();
        let translationKey = value;
        let translationParams = paramsOrKey;

        // 1. Soporte para objeto de configuración: { key: '...', params: {...} }
        if (typeof value === 'object' && value.key && !value[currentLang]) {
            translationKey = value.key;
            translationParams = value.params;
        }

        let translation = '';

        // 2. Lógica de Resolución
        if (this.isTranslationMap(translationKey)) {
            // Caso: El valor es un objeto de base de datos { es: '...', en: '...' }
            translation = this.getFromMap(translationKey, currentLang);
        } else if (typeof translationKey === 'string') {
            // Caso: Es una clave del diccionario UI (ej: 'admin.branding.title')
            translation = this.resolveKey(translationKey, this.langService.ui) || translationKey;
        }

        // 3. Interpolación de variables {{param}}
        if (translationParams && translation) {
            Object.keys(translationParams).forEach(key => {
                translation = translation.replace(
                    new RegExp(`{{${key}}}`, 'g'),
                    String(translationParams[key])
                );
            });
        }

        return translation;
    }

    /**
     * Extrae el texto de un mapa de idiomas con fallback agresivo.
     */
    private getFromMap(map: Record<string, string>, lang: string): string {
        return map[lang] ||           // 1. Idioma actual
            map['es'] ||           // 2. Fallback base Español
            map['en'] ||           // 3. Fallback Internacional
            Object.values(map)[0] || // 4. Primer valor disponible
            '';                    // 5. Vacío
    }

    /**
     * Verifica si el objeto es un mapa de traducciones (ej. datos de Supabase).
     */
    private isTranslationMap(obj: any): obj is Record<string, string> {
        return obj !== null && typeof obj === 'object' && !obj.key;
    }

    private resolveKey(path: string, obj: any): string | null {
        if (!path || !obj) return null;

        const parts = path.split('.');
        let current = obj;

        for (const part of parts) {
            if (current === null || current === undefined || current[part] === undefined) {
                return null;
            }
            current = current[part];
        }

        // Si el resultado final de la ruta es un objeto, aplicamos fallback de idiomas
        if (typeof current === 'object' && current !== null) {
            return this.getFromMap(current, this.langService.currentLang());
        }

        return String(current);
    }
}